import axios from "axios";

export default {
    state: {
        isAdmin: false
    },
    mutations: {
        changeAdminRoot(state, value) {
            state.isAdmin = value;
        }
    },
    actions: {
        async getDetails({commit}) {
            let details = await axios.post(
                process.env.VUE_APP_API + '/details', localStorage.user, {
                    headers: {
                        "Authorization": localStorage.token
                    }
                })
            commit('changeAdminRoot', details.data.is_admin)
            return details;
        },
        async changeUserData({ctx}, payload) {
            return await axios.post(process.env.VUE_APP_API + '/change-user', payload, {
                headers: {
                    "Authorization": localStorage.token
                }
            })
        },
        async changeMail({ctx}, payload) {
            return await axios.post(process.env.VUE_APP_API + '/change-email', payload, {
                headers: {
                    "Authorization": localStorage.token
                }
            })
        },
        async requestToChangeEmail({ctx}, payload) {
            return await axios.post(process.env.VUE_APP_API + '/request-to-change-email', payload, {
                headers: {
                    "Authorization": localStorage.token
                }
            })
        }
    },
    getters: {
        isAdmin: state => state.isAdmin ?? false,
    },
}